import { refresh } from '../api/app';
import { resetStore } from '../redux/actions/loginAction';
import store from '../redux/store';

export const setAuthDataToLocalStorage = (data) => {
  const authData = {
    userUuid: data.user?.uuid,
    accessToken: data.token,
    refreshToken: data.refreshToken,
    accessExpDate: data.expToken,
    refreshExpDate: data.expRToken,
    playbackAuthVersion: `${Date.now()}-${Math.random()}`, // Non-secret identity for cross-tab playback-session freshness checks
  };

  localStorage.setItem('authData', JSON.stringify(authData));
};

export const getAuthDataFromLocalStorage = () => {
  const authData = JSON.parse(localStorage.getItem('authData'));
  return authData;
};

export const removeAuthDataFromLocalStorage = () => {
  localStorage.removeItem('authData');
};

export const getAccessToken = () => {
  const authData = JSON.parse(localStorage.getItem('authData'));

  if (authData && authData.accessToken) {
    return authData.accessToken;
  }

  return null;
};

export const checkStorageChanges = (event, callbacks = {}) => {
  if (event.key === 'authData') {
    if (!event.newValue) {
      callbacks.resetUser();
    } else if (event.newValue && !event.oldValue) {
      window.location.reload();
    }
  }
};

export const refreshToken = () => {
  const authData = getAuthDataFromLocalStorage();
  const tokenPrev = authData.accessToken;

  navigator.locks.request('auth_refresh_lock', async () => {
    const tokenNow = getAccessToken();

    if (tokenPrev !== tokenNow) return;

    try {
      const results = await refresh(authData.refreshToken);
      setAuthDataToLocalStorage(results);
      document.dispatchEvent(new CustomEvent('refreshToken'));
    } catch (error) {
      if (error.status === 401) {
        removeAuthDataFromLocalStorage();
        store.dispatch(resetStore());
      }
    }
  });
};
